import { CodeV2 as Code } from '@/redux/apis/codes-api';
import { API_TO_URL, IMAGES_API_URL } from '../env';

export const useGetShortLink = () => {
  return ({ slug }: Code) => `${API_TO_URL}/${slug}`;
};

export const useGetScanLink = () => {
  const getShortLink = useGetShortLink();

  return (code: Code) => `${getShortLink(code)}?scan=true`;
};

export const useGetImageLink = () => {
  return (code: Code, ext: 'png' | 'svg') => {
    const normalizedCode = code.codeName.replace(/[^a-zA-Z0-9]/g, '-');

    return `${IMAGES_API_URL}/v1/qr/codes/${code.slug}/${normalizedCode}.${ext}`;
  };
};
